export function formatWithOffset(
  input: Date | string | number,
  tz: string, // e.g. "Europe/Kyiv" or viewer's TZ
  locale: string | undefined = 'uk-UA',
) {
  const d = new Date(input);

  // Format date/time in the target timezone
  const base = d.toLocaleString(locale, {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  // Get "+HH:MM" for that timezone at that moment, then normalize to "+HHMM"
  const parts = new Intl.DateTimeFormat('en', {
    timeZone: tz,
    timeZoneName: 'longOffset',
  }).formatToParts(d);
  const offset = (parts.find((p) => p.type === 'timeZoneName')?.value ?? '')
    .replace(/^GMT|UTC/, '')
    .replace(':', '');

  return `${base} ${offset}`;
}
